


































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { UserService, User } from '@/api'

@Component({ components: { PulseLoader } })
export default class Profile extends Vue {
  public loaded = false
  public user: User | null = null

  mounted (): void {
    UserService.getUserSelf().then((user) => {
      this.user = user
    }).finally(() => {
      this.loaded = true
    })
  }
}
